/**
 * Global GA4 Analytics Event Names
 * Standardized event action names for tracking throughout the app.
 * Use these constants instead of hardcoding event strings.
 */
export const GA4_EVENTS = {
  // App Decomposition / Retirement Workflow
  DECOM_WORKFLOW_OPENED: 'App_Decom_Workflow_Opened',
  DECOM_RETIRE_ACKNOWLEDGED: 'App_Decom_Retire_Acknowledged',
  DECOM_RETIRE_SAVED: 'App_Decom_Retire_Saved',
  // New Marketplace
  NEW_MARKETPLACE_CTA_CLICKED: 'New_Marketplace_CTA_Clicked',
  // My Tools
  MY_TOOLS_CGA_REPORT_CLICKED: 'My_Tools_CGA_Report_Clicked',
  // CGA Hierarchy Report
  CGA_REPORT_GENERATED: 'CGA_Report_Generated',
} as const;

export type GA4EventKey = keyof typeof GA4_EVENTS;
